import {
    OfferForPresentmentFn,
    initOfferForPresentmentFn,
} from './lib/methods/offer-for-presentment';
import {
    CheckVehicleStatusByRadioIdFn,
    initCheckVehicleStatusByRadioIdFn,
} from './lib/methods/check-vehicle-status-by-radio-id';
import {
    CheckVehicleStatusByVinFn,
    initCheckVehicleStatusByVinFn,
} from './lib/methods/check-vehicle-status-by-vin';
import {
    CreateOrderForAutomotiveFn,
    initCreateOrderForAutomotiveFn,
} from './lib/methods/create-order-for-automotive';
import {
    ConfirmOrderFn,
    initConfirmOrderFn,
} from './lib/methods/confirm-order';
import { GetOrderFn, initGetOrderFn } from './lib/methods/get-order';
import {
    GetAutomotiveSubscriptionStatusByRadioIdFn,
    initGetAutomotiveSubscriptionStatusByRadioId,
} from './lib/methods/get-automotive-subscription-status-by-radio-id';
import {
    GetAutomotiveSubscriptionStatusByVinFn,
    initGetAutomotiveSubscriptionStatusByVin,
} from './lib/methods/get-automotive-subscription-status-by-vin';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    GetCampaignContentForOfferFn,
    initGetCampaignContentForOfferFn,
} from './lib/methods/get-campaign-content-for-offer';
import {
    CreateOrderForStreamingFn,
    initCreateOrderForStreamingFn,
} from './lib/methods/create-order-for-streaming';
import {
    CreateOrderForSubscriptionCancellationFn,
    initCreateOrderForSubscriptionCancellationFn,
} from './lib/methods/create-order-for-subscription-cancellation';
import {
    ConfirmOrderForSubscriptionCancellationFn,
    initConfirmOrderForSubscriptionCancellationFn,
} from './lib/methods/confirm-order-for-subscription-cancellation';
import {
    initOffersSaveForPresentmentFn,
    OffersSaveForPresentmentFn,
} from './lib/methods/offers-save-for-presentment';
import {
    CreateOrderForSubscriptionChangeFn,
    initCreateOrderForSubscriptionChangeFn,
} from './lib/methods/create-order-for-subscription-change';
import {
    GetCampaignContentForConfirmationFn,
    initGetCampaignContentForConfirmationFn,
} from './lib/methods/get-campaign-content-for-confirmation';
import {
    ConfirmOrderStripeFn,
    initConfirmOrderStripeFn,
} from './lib/methods/confirm-order-stripe';
import {
    ConfirmOrderForSubscriptionChangeFn,
    initConfirmOrderForSubscriptionChangeFn,
} from './lib/methods/confirm-order-for-subscription-change';
import {
    OfferHasPartnerProductFn,
    offerHasPartnerProductFn,
} from './lib/methods/offer-has-partner-product';
import {
    GetDeviceInfoByRadioIdSMSFn,
    initGetDeviceInfoByRadioIdSMSFn,
} from './lib/methods/get-device-info-by-radio-id-sms';
import {
    GetDeviceInfoByVinSMSFn,
    initGetDeviceInfoByVinSMSFn,
} from './lib/methods/get-device-info-by-vin-sms';
import {
    getNonStreamingCustomerOffersSMS,
    GetNonStreamingCustomerOffersSMSFn,
} from './lib/methods/get-non-streaming-customer-offers-sms';
import {
    GetDeviceInfoByLicensePlateSmsFn,
    initGetDeviceInfoByLicensePlateSmsFn,
} from './lib/methods/get-device-info-by-license-plate-sms';

export interface DomainAcquisitions {
    offerForPresentment: OfferForPresentmentFn;
    offerHasPartnerProduct: OfferHasPartnerProductFn;
    offersSaveForPresentment: OffersSaveForPresentmentFn;
    checkVehicleStatusByRadioId: CheckVehicleStatusByRadioIdFn;
    checkVehicleStatusByVin: CheckVehicleStatusByVinFn;
    createOrderForAutomotive: CreateOrderForAutomotiveFn;
    createOrderForStreaming: CreateOrderForStreamingFn;
    createOrderForSubscriptionChange: CreateOrderForSubscriptionChangeFn;
    createOrderForSubscriptionCancellation: CreateOrderForSubscriptionCancellationFn;
    confirmOrder: ConfirmOrderFn;
    confirmOrderStripe: ConfirmOrderStripeFn;
    confirmOrderForChange: ConfirmOrderForSubscriptionChangeFn;
    confirmOrderForCancellation: ConfirmOrderForSubscriptionCancellationFn;
    getAutomotiveSubscriptionStatusByRadioId: GetAutomotiveSubscriptionStatusByRadioIdFn;
    getAutomotiveSubscriptionStatusByVin: GetAutomotiveSubscriptionStatusByVinFn;
    getDeviceInfoByLicensePlateSMS: GetDeviceInfoByLicensePlateSmsFn;
    getDeviceInfoByRadioIdSMS: GetDeviceInfoByRadioIdSMSFn;
    getDeviceInfoByVinSMS: GetDeviceInfoByVinSMSFn;
    getNonStreamingCustomerOffersSMS: GetNonStreamingCustomerOffersSMSFn;
    getOrder: GetOrderFn;
    getCampaignContentForOffer: GetCampaignContentForOfferFn;
    getCampaignContentForConfirmation: GetCampaignContentForConfirmationFn;
}

export function domainAcquisitions(
    domainInitPayload: DomainInitPayload,
): DomainAcquisitions {
    return {
        offerForPresentment: initOfferForPresentmentFn(domainInitPayload),
        offerHasPartnerProduct: offerHasPartnerProductFn(domainInitPayload),
        offersSaveForPresentment:
            initOffersSaveForPresentmentFn(domainInitPayload),
        checkVehicleStatusByRadioId:
            initCheckVehicleStatusByRadioIdFn(domainInitPayload),
        checkVehicleStatusByVin:
            initCheckVehicleStatusByVinFn(domainInitPayload),
        createOrderForAutomotive:
            initCreateOrderForAutomotiveFn(domainInitPayload),
        createOrderForStreaming:
            initCreateOrderForStreamingFn(domainInitPayload),
        createOrderForSubscriptionChange:
            initCreateOrderForSubscriptionChangeFn(domainInitPayload),
        createOrderForSubscriptionCancellation:
            initCreateOrderForSubscriptionCancellationFn(domainInitPayload),
        confirmOrder: initConfirmOrderFn(domainInitPayload),
        confirmOrderStripe: initConfirmOrderStripeFn(domainInitPayload),
        confirmOrderForChange:
            initConfirmOrderForSubscriptionChangeFn(domainInitPayload),
        confirmOrderForCancellation:
            initConfirmOrderForSubscriptionCancellationFn(domainInitPayload),
        getAutomotiveSubscriptionStatusByRadioId:
            initGetAutomotiveSubscriptionStatusByRadioId(domainInitPayload),
        getAutomotiveSubscriptionStatusByVin:
            initGetAutomotiveSubscriptionStatusByVin(domainInitPayload),
        getDeviceInfoByLicensePlateSMS:
            initGetDeviceInfoByLicensePlateSmsFn(domainInitPayload),
        getDeviceInfoByRadioIdSMS:
            initGetDeviceInfoByRadioIdSMSFn(domainInitPayload),
        getDeviceInfoByVinSMS: initGetDeviceInfoByVinSMSFn(domainInitPayload),
        getNonStreamingCustomerOffersSMS:
            getNonStreamingCustomerOffersSMS(domainInitPayload),
        getOrder: initGetOrderFn(domainInitPayload),
        getCampaignContentForOffer:
            initGetCampaignContentForOfferFn(domainInitPayload),
        getCampaignContentForConfirmation:
            initGetCampaignContentForConfirmationFn(domainInitPayload),
    };
}

export type { GetCampaignContentFnResponse } from './lib/types/campaign';
